import React, { Component } from 'react';
// import { Trans } from 'react-i18next';
import "../dashboard/Dashboard.css"

class Footer extends Component {
    render() {
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const frontendLocalUrl = process.env.REACT_APP_FRONTEND_LOCAL_API ? process.env.REACT_APP_FRONTEND_LOCAL_API.replace(/\/$/, '') : 'http://localhost:7001';
        const frontendLiveUrl = process.env.REACT_APP_FRONTEND_LIVE_API ? process.env.REACT_APP_FRONTEND_LIVE_API.replace(/\/$/, '') : 'https://bosclub.in';
        
        const rootDomainUrl = process.env.NODE_ENV === "development" 
            ? frontendLocalUrl 
            : (isLocalhost ? 'http://localhost:7001' : frontendLiveUrl);

        // Only render footer if children or valid content is present
        const copyright = (
            <span className="text-center text-sm-left d-block d-sm-inline-block" style={{ color: '#94a3b8', fontSize: '0.75rem', fontWeight: '400' }}>
                Copyright © {new Date().getFullYear()}{' '}
                <a 
                    href={rootDomainUrl} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    style={{ 
                        color: '#ef4444', 
                        fontWeight: '500', 
                        textDecoration: 'none',
                        transition: 'color 0.2s'
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#ff6b6b'}
                    onMouseLeave={(e) => e.target.style.color = '#ef4444'}
                >
                    {window.location.hostname}
                </a>
                . All rights reserved.
            </span>
        );

        const links = (
            <div className="d-flex align-items-center justify-content-center justify-content-sm-end mt-2 mt-sm-0 flex-wrap" style={{ gap: '0.75rem', fontSize: '0.75rem' }}>
                <a 
                    href={`${rootDomainUrl}/support`} 
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#94a3b8', textDecoration: 'none', transition: 'color 0.2s', fontWeight: '500' }}
                    onMouseEnter={(e) => e.target.style.color = '#f8fafc'}
                    onMouseLeave={(e) => e.target.style.color = '#94a3b8'}
                >
                    Help Center
                </a>
                <span style={{ color: '#334155' }}>•</span>
                <a 
                    href={`${rootDomainUrl}/PrivacyPolicy`} 
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#94a3b8', textDecoration: 'none', transition: 'color 0.2s', fontWeight: '500' }}
                    onMouseEnter={(e) => e.target.style.color = '#f8fafc'}
                    onMouseLeave={(e) => e.target.style.color = '#94a3b8'}
                >
                    Privacy Policy
                </a>
                <span style={{ color: '#334155' }}>•</span>
                <a 
                    href={`${rootDomainUrl}/term-condition`} 
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#94a3b8', textDecoration: 'none', transition: 'color 0.2s', fontWeight: '500' }}
                    onMouseEnter={(e) => e.target.style.color = '#f8fafc'}
                    onMouseLeave={(e) => e.target.style.color = '#94a3b8'}
                >
                    Terms
                </a>
            </div>
        );

        return (
            <footer className="footer" id='dashFooter' aria-label="Footer" style={{ borderTop: '1px solid var(--border-color)', padding: '0.5rem 1.5rem' }}>
                <div className="container-fluid">
                    <div className="d-sm-flex justify-content-center justify-content-sm-between align-items-center w-100">
                        {copyright}
                        {links}
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;